import styled from 'styled-components/macro'
import loaderAnimation from './Assets/FlowhubIconAnimation.gif'
import loaderPoster from './Assets/FlowhubIconBackup.png'

const Wrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const IconFrame = styled.div`
  width: 4rem;
  height: 4rem;
  border-radius: var(--radius-md);
  overflow: hidden;
  flex-shrink: 0;
`

const StyledAnimation = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;

  @media (prefers-reduced-motion: reduce) {
    display: none;
  }
`

const StyledPoster = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: none;

  @media (prefers-reduced-motion: reduce) {
    display: block;
  }
`

const StyledMessage = styled.div`
  font-weight: 200;
  /* Semantic heading ink (deep purple in pearl) so the loading message stays
     readable when dark themes re-bind the token. */
  color: var(--text-heading);
  margin-top: 1rem;
  text-align: center;
  font-size: 1rem;
`

export interface RiverLogoLoaderProps {
  loadingMessage?: string
}

export const RiverLogoLoader = ({ loadingMessage }: RiverLogoLoaderProps) => {
  return (
    <Wrap>
      <IconFrame>
        <StyledAnimation
          data-testid="river-logo-loader"
          src={loaderAnimation}
          alt=""
          aria-hidden
        />
        <StyledPoster src={loaderPoster} alt="" aria-hidden />
      </IconFrame>
      {loadingMessage && <StyledMessage>{loadingMessage}</StyledMessage>}
    </Wrap>
  )
}
